<template>
    <va-create-layout>
        <PayWithAmazonEventCharge-form
            :title="title"
            :item="item"
        ></PayWithAmazonEventCharge-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
